'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MINUTE_MS = exports.MINUTE_MS = 60 * 1000;
var HOUR_MS = exports.HOUR_MS = MINUTE_MS * 60;
var DAY_MS = exports.DAY_MS = HOUR_MS * 24;
var ISO_8601_DATE_FORMAT = exports.ISO_8601_DATE_FORMAT = 'yyyy-MM-dd';
var SECONDS_TIMESTAMP_FORMAT = exports.SECONDS_TIMESTAMP_FORMAT = 't';

var DAYS_OF_WEEK = exports.DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];